import { useMemo } from "react";

import type {
  PayinAmountWithFeeLabels,
  PayinFeeSwitchLabels,
} from "@/shared/components/payments/PayinAmountWithFee";
import useTranslations from "@/shared/lang/useTranslations";

/**
 * Copy for the shared amount+fee control, from the WALLET OWNER's point of view: here the user is topping up
 * their own balance, so the modes read "voy a pagar" / "quiero recibir" — not "quiero cobrar", which is the
 * collector wording the `/app/payins` forms use for the same control.
 */
export function useDepositAmountLabels(): PayinAmountWithFeeLabels {
  const { t } = useTranslations("wallets");
  return useMemo(
    () => ({
      modeGross: t("deposit_mode_gross_label"),
      modeNet: t("deposit_mode_net_label"),
      modeGrossHint: t("deposit_mode_gross_hint"),
      modeNetHint: t("deposit_mode_net_hint"),
      inputGross: t("deposit_payer_sends"),
      inputNet: t("deposit_receive_label"),
      derivedNet: (vars) => t("deposit_derived_net_text", vars),
      derivedGross: (vars) => t("deposit_derived_gross_text", vars),
    }),
    [t],
  );
}

export function useDepositFeeSwitchLabels(): PayinFeeSwitchLabels {
  const { t } = useTranslations("wallets");
  return useMemo(
    () => ({
      label: t("deposit_fee_switch"),
      onHint: t("deposit_fee_on_hint"),
      offHint: t("deposit_fee_off_hint"),
      input: t("deposit_amount_input_label"),
      rowPayerSends: t("deposit_payer_sends"),
      rowFee: t("deposit_row_fee"),
      rowCredited: t("deposit_row_credited"),
      free: t("deposit_fee_free"),
    }),
    [t],
  );
}
